/* Trip Ink v5 redesign media (photos + hero sign video), hosted in Trip Ink's 1Dash.Pro Media Storage,
   folder "Website 2026 Redesign". Key = original file name in 03 Website Redesign/assets, value = media id. */
const CDN = 'https://assets.cdn.filesafe.space/Fi48tOMs4jwRmKbTyIqY/media/';

const IDS: Record<string, string> = {
  'hero-sign-loop.mp4': '6ad06078f2103dccac71a07e',
  'k-brian-traditional-snake-dagger-rose-b.jpg': '6ad06077ebf7eb1c9ee3ea24',
  'k-brian-traditional-snake-dagger-rose.jpg': '6ad060773f79dad930504567',
  'k-day-of-the-dead-half-sleeve-closeup.jpg': '6ad06077f2103dccac71a062',
  'k-day-of-the-dead-half-sleeve-woman-full.jpg': '6ad06077b9085bf7a238d8b5',
  'k-desert-wolf-moon-sleeve-woman.jpg': '6ad06077ebf7eb1c9ee3ea25',
  'k-halloween-neon-sketchbook-skull-dice-b.jpg': '6ad06079b9085bf7a238d8f1',
  'k-halloween-neon-sketchbook-skull-dice.jpg': '6ad06079b9085bf7a238d908',
  'k-lion-roses-forearm-blur-c.jpg': '6ad06079b9085bf7a238d8fd',
  'k-mobster-sleeve-no-face-a.jpg': '6ad060799d1e6954dd8cb017',
  'k-mobster-sleeve-no-face-b.jpg': '6ad060799d1e6954dd8cb02e',
  'k-rich-horror-monster-roses-sketch-b.jpg': '6ad0607a9d1e6954dd8cb04f',
  'k-rich-horror-monster-roses-sleeve-sketch.jpg': '6ad0607a9d1e6954dd8cb05f',
  'k-rose-hummingbird-shoulder-blur-a.jpg': '6ad0607a3f79dad93050459f',
  'k-rose-hummingbird-shoulder-blur-b.jpg': '6ad0607a3f79dad9305045ab',
  'k-surreal-hourglass-back-lion-astronaut-a.jpg': '6ad0607cebf7eb1c9ee3eacc',
  'k-surreal-hourglass-back-lion-astronaut-b.jpg': '6ad0607cb9085bf7a238d949',
  'k-vegas-back-roulette-showgirl-a.jpg': '6ad0607c9d1e6954dd8cb0a8',
  'k-vegas-back-roulette-showgirl-b.jpg': '6ad0607c9d1e6954dd8cb0ae',
  'k-vegas-chest-piece-pinup-cards-b.jpg': '6ad0607c3f79dad9305045cb',
  'k-vegas-chest-piece-pinup-cards.jpg': '6ad0607cf2103dccac71a0ca',
  'k-vegas-dice-cards-sleeve-side-b.jpg': '6ad0607df2103dccac71a0de',
  't-k-brian-traditional-snake-dagger-rose-b.jpg': '6ad0607db9085bf7a238d979',
  't-k-brian-traditional-snake-dagger-rose.jpg': '6ad0607d3f79dad9305045df',
  't-k-day-of-the-dead-half-sleeve-closeup.jpg': '6ad0607df2103dccac71a0ea',
  't-k-day-of-the-dead-half-sleeve-woman-full.jpg': '6ad0607d3f79dad9305045eb',
  't-k-desert-wolf-moon-sleeve-woman.jpg': '6ad0607d3f79dad9305045f7',
  't-k-halloween-neon-sketchbook-skull-dice-b.jpg': '6ad0607ef2103dccac71a109',
  't-k-halloween-neon-sketchbook-skull-dice.jpg': '6ad0607ef2103dccac71a115',
  't-k-lion-roses-forearm-blur-c.jpg': '6ad0607e9d1e6954dd8cb0f3',
  't-k-mobster-sleeve-no-face-a.jpg': '6ad06080f2103dccac71a145',
  't-k-mobster-sleeve-no-face-b.jpg': '6ad060809d1e6954dd8cb130',
  't-k-rich-horror-monster-roses-sketch-b.jpg': '6ad06080b9085bf7a238d9b6',
  't-k-rich-horror-monster-roses-sleeve-sketch.jpg': '6ad060809d1e6954dd8cb13a',
  't-k-rose-hummingbird-shoulder-blur-a.jpg': '6ad06080b9085bf7a238d9bc',
  't-k-rose-hummingbird-shoulder-blur-b.jpg': '6ad060803f79dad930504645',
  't-k-surreal-hourglass-back-lion-astronaut-a.jpg': '6ad06081b9085bf7a238d9e9',
  't-k-surreal-hourglass-back-lion-astronaut-b.jpg': '6ad06081f2103dccac71a162',
  't-k-vegas-back-roulette-showgirl-a.jpg': '6ad060819d1e6954dd8cb14b',
  't-k-vegas-back-roulette-showgirl-b.jpg': '6ad060813f79dad930504665',
  't-k-vegas-chest-piece-pinup-cards-b.jpg': '6ad060813f79dad930504671',
  't-k-vegas-chest-piece-pinup-cards.jpg': '6ad06082f2103dccac71a195',
  't-k-vegas-dice-cards-sleeve-side-b.jpg': '6ad060823f79dad930504685',
  't-vault-rick-trip_black-grey_back_01.jpg': '6ad06082b9085bf7a238da25',
  't-vault-rick-trip_black-grey_hand_01.jpg': '6ad060829d1e6954dd8cb16f',
  't-vault-rick-trip_black-grey_sleeve_01.jpg': '6ad06084f2103dccac71a1e9',
  't-vault-rick-trip_color-realism_back_01.jpg': '6ad06084f2103dccac71a1f3',
  't-vault-rick-trip_color-realism_back_02.jpg': '6ad06084f2103dccac71a1e7',
  't-vault-rick-trip_color-realism_chest_01.jpg': '6ad060849d1e6954dd8cb1c2',
  't-vault-rick-trip_color-realism_sleeve_01.jpg': '6ad06085f2103dccac71a201',
  't-vault-rick-trip_color-realism_small_01.jpg': '6ad060849d1e6954dd8cb1c1',
  't-vault-rick-trip_horror_arm_01.jpg': '6ad060859d1e6954dd8cb1e3',
  't-vault-rick-trip_horror_leg_01.jpg': '6ad06085f2103dccac71a221',
  't-vault-rick-trip_horror_sleeve_01.jpg': '6ad06085f2103dccac71a231',
  't-vault-rick-trip_japanese_sleeve_01.jpg': '6ad06086ebf7eb1c9ee3ebc1',
  't-vault-rick-trip_japanese_sleeve_02.jpg': '6ad06086f2103dccac71a23d',
  't-vault-rick-trip_neo-trad_forearm_01.jpg': '6ad06086b9085bf7a238da7b',
  't-vault-rick-trip_neo-trad_forearm_02.jpg': '6ad06086b9085bf7a238da9b',
  't-vault-rick-trip_other_hand_01.jpg': '6ad06086b9085bf7a238daab',
  't-vault-rick-trip_portrait_leg_01.jpg': '6ad060879d1e6954dd8cb21f',
  't-vault-rick-trip_traditional_arm_01.jpg': '6ad06089b9085bf7a238db07',
  't-w-7084.jpg': '6ad06089b9085bf7a238dafc',
  't-w-7085.jpg': '6ad060899d1e6954dd8cb281',
  't-w-7090.jpg': '6ad060893f79dad930504721',
  't-w-7092.jpg': '6ad060899d1e6954dd8cb282',
  't-w-7093.jpg': '6ad06089f2103dccac71a281',
  't-w-7095.jpg': '6ad06089b9085bf7a238db18',
  't-w-7096.jpg': '6ad0608ab9085bf7a238db28',
  't-w-7097.jpg': '6ad0608af2103dccac71a2a9',
  't-w-7098.jpg': '6ad0608aebf7eb1c9ee3ec31',
  't-w-7099.jpg': '6ad0608af2103dccac71a2ba',
  't-w-7101.jpg': '6ad0608aebf7eb1c9ee3ec3d',
  't-w-7104.jpg': '6ad0608b3f79dad930504781',
  't-w-7105.jpg': '6ad0608b3f79dad93050478d',
  't-w-7106.jpg': '6ad0608b9d1e6954dd8cb2cb',
  't-w-7107.jpg': '6ad0608db9085bf7a238dbbd',
  't-w-7108.jpg': '6ad0608d9d1e6954dd8cb2f6',
  't-w-7110.jpg': '6ad0608db9085bf7a238dbbc',
  't-w-7111.jpg': '6ad0608d9d1e6954dd8cb2f5',
  't-w-7112.jpg': '6ad0608db9085bf7a238dbbe',
  't-w-7113.jpg': '6ad0608df2103dccac71a301',
  't-w-7115.jpg': '6ad0608e3f79dad9305047e5',
  't-w-7116.jpg': '6ad0608ef2103dccac71a344',
  't-w-7117.jpg': '6ad0608e9d1e6954dd8cb303',
  't-w-7118.jpg': '6ad0608e3f79dad9305047fa',
  't-w-7120.jpg': '6ad0608eebf7eb1c9ee3eca1',
  't-w-71211.jpg': '6ad0608e3f79dad930504806',
  't-w-71221.jpg': '6ad0608ff2103dccac71a395',
  't-w-7123c.jpg': '6ad060379d1e6954dd8caae2',
  'v3-hero-1600.jpg': '6ad0608febf7eb1c9ee3ecf9',
  'v3-hero-2560.jpg': '6ad0608f3f79dad93050482d',
  'v3-hero-bulbs-phone.jpg': '6ad06091ebf7eb1c9ee3ed14',
  'v3-hero-bulbs.jpg': '6ad06091ebf7eb1c9ee3ed0e',
  'v3-hero-glow-phone.jpg': '6ad06091b9085bf7a238dc78',
  'v3-hero-glow.jpg': '6ad06091f2103dccac71a3d6',
  'v3-hero-phone-1280.jpg': '6ad060913f79dad930504891',
  'v4-halloween-rockhouse.jpg': '6ad06091f2103dccac71a3dc',
  'vault-rick-trip_anime-pop_arm_01.jpg': '6ad06092b9085bf7a238dc8c',
  'vault-rick-trip_black-grey_back_01.jpg': '6ad06092ebf7eb1c9ee3ed3d',
  'vault-rick-trip_black-grey_hand_01.jpg': '6ad060923f79dad9305048a9',
  'vault-rick-trip_black-grey_sleeve_01.jpg': '6ad060923f79dad9305048b5',
  'vault-rick-trip_color-realism_back_01.jpg': '6ad06092ebf7eb1c9ee3ed51',
  'vault-rick-trip_color-realism_back_02.jpg': '6ad06092ebf7eb1c9ee3ed61',
  'vault-rick-trip_color-realism_chest_01.jpg': '6ad060933f79dad9305048dd',
  'vault-rick-trip_color-realism_sleeve_01.jpg': '6ad06093b9085bf7a238dcb4',
  'vault-rick-trip_color-realism_small_01.jpg': '6ad060939d1e6954dd8cb3bc',
  'vault-rick-trip_horror_arm_01.jpg': '6ad06095ebf7eb1c9ee3edc1',
  'vault-rick-trip_horror_leg_01.jpg': '6ad060959d1e6954dd8cb3e2',
  'vault-rick-trip_horror_sleeve_01.jpg': '6ad060959d1e6954dd8cb3d8',
  'vault-rick-trip_japanese_sleeve_01.jpg': '6ad06095b9085bf7a238dd08',
  'vault-rick-trip_japanese_sleeve_02.jpg': '6ad06095f2103dccac71a435',
  'vault-rick-trip_neo-trad_forearm_01.jpg': '6ad06095f2103dccac71a440',
  'vault-rick-trip_neo-trad_forearm_02.jpg': '6ad06096f2103dccac71a471',
  'vault-rick-trip_other_hand_01.jpg': '6ad06096f2103dccac71a491',
  'vault-rick-trip_portrait_leg_01.jpg': '6ad06096ebf7eb1c9ee3ede1',
  'vault-rick-trip_traditional_arm_01.jpg': '6ad060963f79dad93050494e',
  'vault-unknown_black-grey_chest_01.jpg': '6ad06096b9085bf7a238dd2c',
  'vault-unknown_black-grey_chest_02.jpg': '6ad060969d1e6954dd8cb3fb',
  'vault-unknown_color-realism_arm_01.jpg': '6ad060973f79dad93050496d',
  'vault-unknown_color-realism_back_01.jpg': '6ad06097f2103dccac71a4ad',
  'vault-unknown_horror_arm_01.jpg': '6ad060973f79dad93050497d',
  'w-7084.jpg': '6ad06099f2103dccac71a4f8',
  'w-7085.jpg': '6ad06099b9085bf7a238dd69',
  'w-7090.jpg': '6ad06099f2103dccac71a4f7',
  'w-7092.jpg': '6ad060993f79dad9305049bb',
  'w-7093.jpg': '6ad060993f79dad9305049ba',
  'w-7095.jpg': '6ad06099ebf7eb1c9ee3ee31',
  'w-7096.jpg': '6ad0609aebf7eb1c9ee3ee61',
  'w-7097.jpg': '6ad0609ab9085bf7a238dd98',
  'w-7098.jpg': '6ad0609a3f79dad9305049dd',
  'w-7099.jpg': '6ad0609a9d1e6954dd8cb433',
  'w-7101.jpg': '6ad0609a9d1e6954dd8cb43f',
  'w-7104.jpg': '6ad0609b9d1e6954dd8cb44b',
  'w-7105.jpg': '6ad0609b3f79dad930504a10',
  'w-7106.jpg': '6ad0609bebf7eb1c9ee3ee89',
  'w-7107.jpg': '6ad0609b9d1e6954dd8cb45f',
  'w-7108.jpg': '6ad0609debf7eb1c9ee3eeb5',
  'w-7110.jpg': '6ad0609d3f79dad930504a6e',
  'w-7111.jpg': '6ad0609db9085bf7a238dddc',
  'w-7112.jpg': '6ad0609d3f79dad930504a67',
  'w-7113.jpg': '6ad0609d3f79dad930504a6f',
  'w-7115.jpg': '6ad0609d9d1e6954dd8cb4bb',
  'w-7116.jpg': '6ad0609e3f79dad930504ab4',
  'w-7117.jpg': '6ad0609e9d1e6954dd8cb4c7',
  'w-7118.jpg': '6ad0609e3f79dad930504ac0',
  'w-7120.jpg': '6ad0609ef2103dccac71a581',
  'w-71211.jpg': '6ad0609ff2103dccac71a58d',
  'w-71221.jpg': '6ad0609ff2103dccac71a599',
  'w-7123c.jpg': '6ad0609febf7eb1c9ee3eefd',
};

export const TI_ASSETS: Record<string, string> = Object.fromEntries(
  Object.entries(IDS).map(([name, id]) => [name, `${CDN}${id}.${name.split('.').pop()}`]),
);

export const tiAsset = (name: string): string => TI_ASSETS[name] || '';
